import {useIntl} from "react-intl";
import {Field} from "formik";
import React, {useState,useEffect} from "react";
import _ from "lodash";
import toast from "react-hot-toast";
import {AdminService, WLOCreditAPIService} from "../../../services";
import {terms, typeCredit} from "../../../__mocks__/data";
import Moment from 'moment';
import {useRequestContext} from "../../../hooks/useRequestContext";
import ClockLoader from "react-spinners/ClockLoader";
import ParseNumberThousandMedium from "../../shared/Utilities/ParseNumberThousandMedium";
import ParseNumberSmallertext from "../../shared/Utilities/ParseNumberSmallerText";
import NumberFormat from 'react-number-format';

interface FormCreditSimulatorProp {
    errors?: any,
    values?: any,
}

export function FormCreditSimulatorMobile(props: FormCreditSimulatorProp) {
    const {request, setRequest} = useRequestContext();
    const {errors, values} = props;
    const intl = useIntl();
    const [valueQuote, setValueQuote] = React.useState(0);
    const [valueToFinance, setValueToFinance] = React.useState(0);
    const [isLoadingSimulator, setIsSimulator] = useState(false);
    const [isLoadingEmail, setIsEmail] = useState(false);
    const [listCredit, setListcredit] = useState([]);
    const [listPeriodos, setPeriodos] = useState([]);
    const [one] = useState(false);
    useEffect(()=>{
        getValueListCreditos()
    },[one])
    const getValueListCreditos =async () =>{
        const valor= await AdminService.getlineascredito();
        if(valor.payload.data.ListLineaCredito.Datos_LineasCredito.length>0){
            setListcredit(valor.payload.data.ListLineaCredito.Datos_LineasCredito)
        }
        const valor2= await AdminService.getPeriodos();
        if(valor2.payload.data.ListPerido.Datos_Periodo.length>0){
            setPeriodos(valor2.payload.data.ListPerido.Datos_Periodo)
        }
    }
    const handleSendEmail = async (valorcuota:string,valorinicial:string) => {
        setIsEmail(true);
        if (_.isEmpty(values.pws_cod_credi!) || _.isEmpty(values.Pws_Val_pla!) || _.isEmpty(values.Pws_Val_cuoini!) || _.isEmpty(values.pws_nro_cuotas!) || _.isEmpty(values.Pws_Correo!)) {
            toast.error('Debe indicar los valores [Correo, Opción de Crédito, Plazo, Valor cuota inicial, Nro. Cuotas] para poder calcular');
        } else {
            try {
                const emailInfo = {
                    dateSolicitud: Moment(new Date()).format('MM/DD/YYYY'),
                    product: request.nameProduct!,
                    price: request.priceProduct!,
                    cuotas: values.pws_nro_cuotas, 
                    cuotaInicial: valorinicial,
                    valorCuota: valorcuota,
                    email: values.Pws_Correo!,
                }
                console.log(emailInfo)
                const resultEnvioCorreo = await WLOCreditAPIService.sendEmailCotizacion(emailInfo);
                if (resultEnvioCorreo) {
                    toast.success('Se ha enviado con exito el email con la cotización');
                    setIsEmail(false);
                }
            } catch (error) {
                setIsSimulator(true);
                toast.error('En este momento no podemos atender su solicitud');
                setTimeout(() => {
                    setIsSimulator(false);
                }, 4000);
            }
        }
    }

    const handleCalculatedQuote = async (e: any) => {
        e.preventDefault();
        setIsSimulator(true);
        const montoVehiculo = request.priceProduct;
        let cuotaFormated;
        let cuotaNumberFormated;
        let plazo: string;
        if (values) {
            if (_.isEmpty(values.pws_cod_credi!) || _.isEmpty(values.Pws_Val_pla!) || _.isEmpty(values.Pws_Val_cuoini!) || _.isEmpty(values.Pws_Identificacion) || _.isEmpty(values.pws_nro_cuotas!)) {
                toast.error('Debe indicar los valores [Opción de Crédito, Plazo, Valor cuota inicial, Nro de Cuotas e Identificación] para poder calcular');
                setIsSimulator(false);
            } else {
                try {
                    cuotaFormated = values.Pws_Val_cuoini.replaceAll(',', '');
                    cuotaNumberFormated = values.pws_nro_cuotas.replaceAll(',', '');
                    if (parseFloat(cuotaFormated) > parseFloat(montoVehiculo!)) {
                        toast.error('La cuota inicial debe ser menor al valor del producto');
                        return;
                    }
                    if (parseFloat(cuotaNumberFormated) > 999) {
                        toast.error('El nro de cuota no puede ser mayor a 999');
                    }
                    else {
                        plazo = values.Pws_Val_pla;
                        const valorToFinanciar = String(parseFloat(montoVehiculo!) - parseFloat(cuotaFormated));
                        const codProducto = sessionStorage.getItem('CodProducto');
                        const esFlujoSeguros = codProducto === '2';
                        const fechaSol = Moment(new Date()).format('MM/DD/YYYY');
                        let simulador;
                        if (esFlujoSeguros) {
                            const lineaSeleccionada = listCredit.find((item: any) => item.s_codigo === values.pws_cod_credi);
                            const tasaLinea = (lineaSeleccionada as any)?.s_tasa;
                            const pwsTasaInt = tasaLinea !== undefined && tasaLinea !== null && String(tasaLinea).trim() !== '' ? String(tasaLinea).trim() : '0';
                            const datosPoliza = sessionStorage.getItem('datos_Poliza') ? JSON.parse(sessionStorage.getItem('datos_Poliza')!) : {};
                            const pwsTipDomi = datosPoliza.plan || '';
                            simulador = await WLOCreditAPIService.simulaPoliza({
                                pws_monto: valorToFinanciar!,
                                pws_nro_cuotas: values.pws_nro_cuotas!,
                                pws_fecha_sol: fechaSol,
                                pws_cod_credi: values.pws_cod_credi!,
                                pws_form_plazo: plazo,
                                pws_identific: values.Pws_Identificacion,
                                pws_form_periodic: plazo,
                                pws_tasa_int: pwsTasaInt,
                                pws_tip_domi: pwsTipDomi
                            });
                        } else {
                            simulador = await WLOCreditAPIService.getSimulador({
                                pws_monto: valorToFinanciar!,
                                pws_nro_cuotas: values.pws_nro_cuotas!,
                                pws_fecha_sol: fechaSol,
                                pws_cod_credi: values.pws_cod_credi!,
                                pws_form_plazo: plazo,
                                pws_identific: values.Pws_Identificacion,
                                pws_form_periodic: plazo
                            });
                        }
                        
                       if (!_.isEmpty(simulador.payload) && !_.isEmpty(simulador.payload.data)) {
                            const valorQuote = simulador.payload.data.R_Val_cuota;
                            values.Pws_Val_cuo=valorQuote;
                            values.Pws_Val_finan=valorToFinanciar;
                            setValueToFinance(parseFloat(valorToFinanciar));
                            setValueQuote(valorQuote);
                            const infoCredit = simulador;  
                            setRequest({
                                ...request,
                                valueOfInicialQuote: values.Pws_Val_cuoini!,
                                valueOfQuote: valorQuote,
                                valueToFinance: valorToFinanciar.toString(),
                                simulator: infoCredit,
                                isRotativo:Boolean(listCredit.filter((valorflitro:any)=>valorflitro.s_codigo==values.pws_cod_credi)[0]['s_rotativo'])
                            });
                            toast.success('Se ha generado un nuevo calculo de cuota');
                            handleSendEmail(valorQuote,String(values.Pws_Val_cuoini!))
                            setIsSimulator(false);
                        }
                    }
                } catch (e) {
                    setIsSimulator(true);
                    toast.error('En este momento no podemos atender su solicitud');
                    setTimeout(() => {
                        setIsSimulator(false);
                    }, 4000);
                }

            }
        }
    }


    return (
        <div className={'row'}>
            <ClockLoader id='spinner' color={"#d72222"} loading={isLoadingSimulator} size={50}/>
            <ClockLoader id='spinner' color={"#d72222"} loading={isLoadingEmail} size={50}/>
            <div>
                <img className="img-fluid" src={request.imagemoto} alt={''}/>
            </div>
            <div
                className={"title-large-bold-mobile"}>{intl.formatMessage({id: "form_credit_information_promotion_title"})}</div>
            <div id={"model-product"}
                 className={"title-large-red-mobile"}>{request.nameProduct}</div>
            <div id={"price-product"}
                 className={"title-large-mobile"}><NumberFormat value={parseInt(request.priceProduct!)} displayType={'text'} thousandSeparator={true} prefix={'$'}/></div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>

                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <div className={"subtitle-medium-mobile"}>{intl.formatMessage({id: "option_credit"})}</div>
                    <Field as="select"
                           id={"pws_cod_credi"}
                           className={`${errors.pws_cod_credi ? 'form-know-you-item-input-mobile input-error' : 'form-know-you-item-input-mobile'}`}
                           name="pws_cod_credi">
                        <option>{intl.formatMessage({id: "option_credit"})}</option>
                        {listCredit && listCredit.map((item:any, key: number) => {
                            return (
                                <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                            )
                        })}
                    </Field>
                </div>
            </div>
            <div className="col-3"/>
            <div className="col-6">
                <div
                    className={"subtitle-medium-mobile"}>{intl.formatMessage({id: "form_credit_information_selection"})}</div>
            </div>
            <div className="col-3"/>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"Pws_Val_cuoini"}
                           name={"Pws_Val_cuoini"}
                           component={ParseNumberThousandMedium}
                           placeholder={intl.formatMessage({id: "placeholder_initial_quote_symbol"})}

                           className={'form-know-you-item-input-mobile'}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"pws_nro_cuotas"}
                           name={"pws_nro_cuotas"}
                           component={ParseNumberThousandMedium}
                           placeholder={intl.formatMessage({id: "nro_quotes"})}
                           className={'form-know-you-item-input-mobile'}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field as="select" id={"Pws_Val_pla"}
                           className={`${errors.Pws_Val_pla ? 'form-know-you-item-input-mobile input-error' : 'form-know-you-item-input-mobile'}`}
                           name="Pws_Val_pla">
                        <option>{intl.formatMessage({id: "term"})}</option>
                        {terms && terms.WS_PERIODOResult.ListPerido.Datos_Periodo.map((item, key: number) => {
                            return (
                                <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                            )
                        })}
                    </Field>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <div className="roundNumberFormat " >
                    <NumberFormat value={parseInt(request.valueToFinance!)} displayType={'text'} thousandSeparator={true} prefix={'$'}/>

                    </div>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                <div className="roundNumberFormat text-center">
                    <NumberFormat value={parseFloat(request.valueOfQuote!)} displayType={'text'} thousandSeparator={true} prefix={'$'}/>

                    </div>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <div className={"form-know-you-item-button"} onClick={handleCalculatedQuote}>
                        {intl.formatMessage({id: "button_calculate_quote"})}
                    </div>
                </div>
            </div>
            <div className="col-3"/>
            <div className="col-6">
                <div className={"subtitle-medium-mobile"}>
                    {intl.formatMessage({id: "form_credit_information_note"})}
                </div>
            </div>
            <div className="col-4"/>
         
        </div>
        
    )
}